<template>
  <div class="advert-li" @click="goDetail">
    <img class="adv-img" :src="imgUrl"/>

    <div class="badge-m">广告</div>
  </div>
</template>

<script>
import {AdvertsService} from '@digital-supply-chain/module'
import { ApiService } from "@/libs"

import CompIcon from "/@/components/icon/comp-icon.vue";

export default {
  props: {
    comp: { default: {} },
  },
  components: { CompIcon },
  computed: {
    imgUrl() {
      return ApiService.ImageHost + this.comp.imageUrl
    }
  },
  data() {
    return {
      ApiService,
    }
  },
  methods: {
    goDetail() {
      AdvertsService.openAdvertInfo(this.comp.advId, this.comp.targetUrl);
    }
  },
}
</script>

<style lang="less" scoped>
  .advert-li{
    position: relative;
    border: 1px solid #EEEEEE;
    font-size: 0;
    min-width: 130px;
    max-width: 160px;
    max-height: 160px;
    margin: 0 5px 10px 5px;
    flex: 1;
    text-decoration: none;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
    .adv-img{
      max-width: 100%;
      max-height: 100%;
      object-fit: scale-down;
    }
    .badge-m{
      position: absolute;
      top: 0px;
      right: 0px;
      font-size: 12px;
      color: #ffffff;
      width: 32px;
      height: 16px;
      text-align: center;
      background: rgba(51, 51, 51, 0.6);
      line-height: 15px;
    }
  }
</style>
